export default "__VITE_ASSET__D2Rdqk7c__"